module.exports = __webpack_public_path__ + "static/media/font_medium.05e661e3.woff2";